const COMPILED_CONSTANTS = {
    "evolveAppInferenceProfileArn": "arn:aws:bedrock:us-east-1:002616177716:application-inference-profile/6obqzdwq6v8b",
    "evolveAppInferenceProfile46Arn": "arn:aws:bedrock:us-east-1:002616177716:application-inference-profile/hm4jc1voz4dv",
    "evolveContractIngestionApiGatewayId": "9bdzh95wfe",
    "evolveSettlementApiGatewayId": "lzl450f0e4",
    "evolveNexusPublicApiGatewayId": "xfb1exwjd9",
    "evolveNexusApiGatewayId": "tq3y01bzt0",
    "evolveOSApiGatewayId": "lm0go886t8",
    "evolveApiAlertsTopicArn": "arn:aws:sns:us-east-1:002616177716:api-alerts-topic",
    "evolveNascoNexusRedshiftRole": "arn:aws:iam::002616177716:role/nasco-evolve-redshift-role-nexus",
    "evolveRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:002616177716:workgroup/eac65d7e-3a4f-4560-9901-d3db41d479fe",
    "RedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:002616177716:workgroup/eac65d7e-3a4f-4560-9901-d3db41d479fe",
    "evolveRedshiftSnapshotLambdaRoleArn": "arn:aws:iam::002616177716:role/nasco-evolve-redshift-snapshot-lambda-role",
    "evolvenexusToProcessBucketName": "evolve-nexus-to-process-002616177716-us-east-1",
    "evolvemediaBucketName": "evolve-media-002616177716-us-east-1",
    "evolvesynthDataBucketName": "evolve-synth-data-002616177716-us-east-1",
    "evolveAwsAccountId": "002616177716",
    "evolvenexusFailedProcessingBucketName": "evolve-nexus-failed-processing-002616177716-us-east-1",
    "evolvemigrationBucketName": "evolve-migration-002616177716-us-east-1",
    "evolvereportsBucketName": "evolve-reports-002616177716-us-east-1",
    "evolvedevBucketName": "evolve-dev-002616177716-us-east-1",
    "evolvesettlementArtifactsBucketName": "evolve-settlement-artifacts-002616177716-us-east-1",
    "evolvenexusProcessedBucketName": "evolve-nexus-processed-002616177716-us-east-1",
    "evolvequarantineBucketName": "evolve-quarantine-002616177716-us-east-1",
    "evolvetemporaryBucketName": "evolve-temporary-002616177716-us-east-1",
    "evolveflowArtifactsBucketName": "evolve-flow-artifacts-002616177716-us-east-1",
    "evolvedynamoBucketName": "evolve-dynamo-002616177716-us-east-1",
    "evolvecontractUploadsBucketName": "evolve-contract-uploads-002616177716-us-east-1",
    "evolveexportDynamoBucketName": "evolve-export-dynamo-002616177716-us-east-1",
    "evolvememoriesBucketName": "evolve-memories-002616177716-us-east-1",
    "securityGroupId": "sg-0bf26cbcf567e7501",
    "evolveUserPoolId": "us-east-1_uiYLgzT8h",
    "evolveGuardDutyMalwareAlertTopicArn": "arn:aws:sns:us-east-1:002616177716:guardduty-malware-alerts",
    "evolveUserPoolClientId": "1oqb52phsvmgsq20jvujujs4mf",
    "evolveCognitoDomain": "vbc-002616177716-us-east-1",
    "evolveSecurityGroupId": "sg-0bf26cbcf567e7501",
    "evolveNexusCloudFrontDistributionArn": "arn:aws:cloudfront::002616177716:distribution/E34G6D06C8S9XU",
    "evolveNexusCloudFrontDistributionId": "E34G6D06C8S9XU",
    "evolveNexusFrontendBucket": "evolve-nexus-frontend-002616177716-us-east-1",
    "evolveNexusSubDomain": "vbc.nexus",
    "evolveOSFrontendBucketName": "evolve-os-frontend-002616177716-us-east-1",
    "evolveOSCloudFrontDistributionArn": "arn:aws:cloudfront::002616177716:distribution/E2QBPO0HNH0TIF",
    "evolveOSSubDomain": "vbc.os",
    "evolveOSCloudFrontDistributionId": "E2QBPO0HNH0TIF",
    "evolveNascoDomain": "vbps.bcbsm.nasco.com",
    "evolveApiProxyUrl": "https://vbc-proxy.vbps.bcbsm.nasco.com",
    "evolveApiCloudFrontDistributionArn": "arn:aws:cloudfront::002616177716:distribution/E1SR4LDPWJNCHB",
    "signingProfileVersionArn": "arn:aws:signer:us-east-1:002616177716:/signing-profiles/signingProfile_5rCWYANiJ0wo/dq2cVnhLND",
    "custodianRoleName": "nasco-c7n",
    "errorTopicArn": "arn:aws:sns:us-east-1:002616177716:c7n-errors",
    "signingProfileName": "signingProfile_5rCWYANiJ0wo",
    "scheduleGroupName": "CloudCustodian",
    "policySGId": "sg-0179162617e44f329",
    "custodianRoleArn": "arn:aws:iam::002616177716:role/nasco-admin/nasco-c7n",
    "scheduleRoleArn": "arn:aws:iam::002616177716:role/nasco-admin/nasco-c7n-schedule",
    "custodianAdminRoleArn": "arn:aws:iam::002616177716:role/nasco-admin/nasco-c7n-admin",
    "tenableOneRoleArn": "arn:aws:iam::002616177716:role/nasco-admin/nasco-tenable-one",
    "bedrockLogging": "Yes",
    "logicMonitorRoleArn": "arn:aws:iam::002616177716:role/nasco-admin/nasco-logicmonitor",
    "snsKMSKeyAliasName": "alias/nasco/sns",
    "cfLoggingBucketName": "cloudfront-logs-002616177716-us-east-1",
    "s3LoggingBucketName": "s3-access-logs-002616177716-us-east-1",
    "breakGlassRoleArn": "arn:aws:iam::002616177716:role/nasco-admin/nasco-break-glass",
    "permsBoundaryPolicyARN": "arn:aws:iam::002616177716:policy/nasco/builder-permissions-boundary",
    "deploymentBucketName": "deployment-002616177716-us-east-1",
    "opsPermsBoundaryPolicyARN": "arn:aws:iam::002616177716:policy/nasco/ops",
    "BaselineCloudFrontACLARN": "arn:aws:wafv2:us-east-1:002616177716:global/webacl/NASCO-CloudFront-Baseline/27714410-ab28-4afb-af37-a52f53fc22e9",
    "TerraformStateBucketName": "tfstate-002616177716-us-east-1",
    "oidcProviderArn": "arn:aws:iam::002616177716:oidc-provider/api.bitbucket.org/2.0/workspaces/nascodevelopment/pipelines-config/identity/oidc",
    "LocalSecurityTopicName": "aws-controltower-SecurityNotifications",
    "LocalSecurityTopic": "arn:aws:sns:us-east-1:002616177716:aws-controltower-SecurityNotifications",
    "BaselineConfigDeliveryChannel": "aws-controltower-BaselineConfigDeliveryChannel",
    "BaselineConfigRecorder": "aws-controltower-BaselineConfigRecorder",
    "BaselineConfigRole": "arn:aws:iam::002616177716:role/aws-controltower-ConfigRecorderRole",
    "env": "dev"
}
export { COMPILED_CONSTANTS }